import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ArraySubsetFormEditorWidget: WidgetRegistryEntry = {
  name: "ArraySubsetFormEditor",
  component: () =>
    import("./array-subset-form-editor-widget.component").then((m) => m.ArraySubsetFormEditorWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.ArraySubsetFormEditorWidgetConfiguration)
};
